import { Box } from '@dtx-company/design-system/src'
import { EmptyNavPageContainer } from '../../layout/EmptyNavPageContainer/EmptyNavPageContainer'
import { Footer } from '../../layout/footer'
import {
  HomePageBelowFoldMockData,
  LOCGPageDescription,
  LOCGPageTitle
} from './HomepageBelowFoldMockData'
import { HomepageBelowFoldExperimentData } from '@app/code/src/components/Homepage/HomepageStaticContent/variants/types'
import { HowToSchema } from '@app/code/src/components/Homepage/HowToSchema'
import { LOCGPrismicProvider } from '@app/code/src/components/LoggedOutCodeGeneratorV2/LOCGPrismicContext'
import { LocgV2DataMock } from './LocgMockData'
import { LockedFeatureModal } from '../../../shared/common/src/components/LockedFeatureModal/LockedFeatureModal'
import { LoggedOutCodeGenerator } from '@app/code/src/components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator'
import { MarketingTopNav } from '../../TopNav/v2/MarketingTopNav'
import { Meta } from '../../../constants/meta'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { ThemeFlow2Provider } from '@dtx-company/design-system/src/components/ThemeProvider/ThemeFlow2Provider'
import { topNavData } from '../../layout/header/v2/topNavData'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import dynamic from 'next/dynamic'

const LongAndColorful = dynamic<{ data: HomepageBelowFoldExperimentData['v2'] }>(() =>
  import(
    '@app/code/src/components/Homepage/HomepageStaticContent/variants/V2-LongAndColorful'
  ).then(mod => mod.LongAndColorful)
)

export interface FreeQrCodeGeneratorPageProps {
  injectedMeta?: Meta
  swrFallback?: Record<string, unknown>
}

export const FreeQrCodeGeneratorPage = (props: FreeQrCodeGeneratorPageProps): JSX.Element => {
  const { injectedMeta } = props
  const { isMobile } = useScreenSizeBreakpoints()
  const { isAuthenticated } = useAuthState()

  return (
    <ThemeFlow2Provider>
      <EmptyNavPageContainer
        page={Routes.FREE_QR_CODE_GENERATOR}
        stickyHeader={true}
        injectedMeta={{
          ...injectedMeta,
          description: LOCGPageDescription,
          title: LOCGPageTitle
        }}
        header={
          <MarketingTopNav
            isFlowpageRoute={false}
            isLoggedIn={isAuthenticated}
            topNavPrismic={topNavData}
          />
        }
      >
        <LOCGPrismicProvider locgV2Data={LocgV2DataMock}>
          <Box>
            <LoggedOutCodeGenerator />
            {!isMobile && <LongAndColorful data={HomePageBelowFoldMockData} />}
          </Box>
        </LOCGPrismicProvider>
        <HowToSchema />
        {!isMobile && <Footer />}
        <LockedFeatureModal />
      </EmptyNavPageContainer>
    </ThemeFlow2Provider>
  )
}
